export default "__VITE_ASSET__DfJkshov__"